module.exports = __webpack_public_path__ + "media/images/expert__sven-fischer-6e0897311f4dfb80fbbcbd8c6e5f2b2d.png";